// Khối "Cài đặt chung" của bot Telegram: bật/tắt, tài khoản đứng tên bài, lệnh xoá,
// lọc hashtag, nơi nhận báo kết quả. Tách khỏi modal cho mỗi file còn ngắn.
import React from "react";
import { Switch, Input, InputNumber, AutoComplete } from "antd";

/** Ô nhập: nhãn trên, ô giữa, giải thích xám dưới (thay cho một rừng Tag nhìn rối). */
const Field = ({ label, hint, children }) => (
    <div>
        <div className="text-sm mb-1">{label}</div>
        {children}
        {hint && <div className="text-xs text-gray-500 mt-1">{hint}</div>}
    </div>
);

export default function TelegramGeneralSettings({ config, patch, loading, ownerName, senderOptions }) {
    return (
        <>
            {/* Công tắc nằm RIÊNG một hàng ngang: nhét vào lưới thì nhãn/nút/giải thích
                rơi xuống 3 dòng, chiếm chỗ mà chẳng đọc dễ hơn. */}
            <div className="flex items-center gap-2 mb-4">
                <Switch
                    checked={config.enabled}
                    loading={loading}
                    onChange={(enabled) => patch({ enabled })}
                />
                {/* Nhãn và lời giải thích trước đây dính sát nhau, đọc thành một cụm.
                    Tách ra: nhãn đứng riêng, giải thích lùi vào và bỏ dấu gạch đầu. */}
                <span className="font-medium">{config.enabled ? "Đang bật" : "Đang tắt"}</span>
                <span className="ml-2 text-xs text-gray-500">
                    {config.enabled ? "bot đang nghe và đăng bài" : "bot không đăng gì"}
                </span>
            </div>

            <div className="grid grid-cols-2 gap-4">
                {/* Nói rõ "trên longhousee": cả bảng này toàn id Telegram nên rất dễ tưởng
                    ô này cũng là id Telegram rồi điền nhầm. */}
                <Field
                    label="Tài khoản đứng tên bài (userId trên longhousee)"
                    hint={
                        ownerName
                            ? `${ownerName} — tài khoản app longhousee, không phải id Telegram`
                            : "Id tài khoản trên app longhousee (không phải id Telegram) — bắt buộc khi bật"
                    }
                >
                    <InputNumber
                        className="w-full"
                        min={1}
                        value={config.ownerUserId}
                        onChange={(ownerUserId) => patch({ ownerUserId })}
                    />
                </Field>

                <Field label="Lệnh xoá bài" hint="Trả lời lệnh này vào tin cần gỡ khỏi app">
                    <Input
                        value={config.deleteCommand}
                        onChange={(e) => patch({ deleteCommand: e.target.value })}
                    />
                </Field>

                {/* Nhóm còn dùng để nhắn nội bộ, không phải tin nào cũng muốn lên app. */}
                <Field
                    label="Chỉ đăng tin có hashtag"
                    hint={
                        config.requiredHashtag
                            ? `Tin không có ${config.requiredHashtag} bị bỏ qua — thẻ tự gỡ khỏi bài`
                            : "Đang đăng MỌI tin của người trong danh sách"
                    }
                >
                    <Input
                        placeholder="vd #dang (bỏ trống = đăng tất)"
                        value={config.requiredHashtag || ""}
                        onChange={(e) => patch({ requiredHashtag: e.target.value })}
                    />
                </Field>

                {/* Bot KHÔNG trả lời trong nhóm/kênh nữa — mỗi bài mọc thêm 1 tin làm bẩn kênh. */}
                <Field
                    label="Báo kết quả riêng cho (chatId)"
                    hint={
                        config.notifyChatId
                            ? "Bot nhắn riêng “đã đăng / đã xoá”, không nhắn trong nhóm"
                            : "Không báo gì, kết quả chỉ nằm ở log telegram-worker"
                    }
                >
                    <AutoComplete
                        className="w-full"
                        placeholder="id Telegram của bạn"
                        options={senderOptions}
                        value={config.notifyChatId || ""}
                        onChange={(notifyChatId) => patch({ notifyChatId })}
                        filterOption={(input, option) =>
                            String(option?.label || "").toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </Field>
            </div>
            <div className="text-xs text-gray-500 mt-2">
                Muốn nhận tin riêng thì phải bấm Start với bot trước, và điền id SỐ (@username không
                gửi được).
            </div>
        </>
    );
}
